import { lazy } from 'react';

// Dashboard
export const Dashboard = lazy(() => import(/* webpackChunkName: "dashboard" */ './dashboard'));

// Dubizzle Login
export const Login = lazy(() => import('./login'));

export const Signup = lazy(() => import('./signup'));

// Reset Password
export const ResetPassword = lazy(() => import(/* webpackChunkName: "reset-password" */ './reset-password'));

// Mange Products
export const ManageProducts = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "manage-products" */ './products/manage-products')
);

// Manage Orders
export const ManageOrders = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "manage-orders" */ './orders/manage-orders')
);

// Return Orders
export const ScReturnOrders = lazy(
  () => import(/* webpackChunkName: "return-orders" */ './orders/return-orders'),
);

// Shipment Orders
export const Shipments = lazy(() => import(/* webpackChunkName: "shipment-orders" */ './orders/shipment-orders'));

// Review Orders
export const Reviews = lazy(() => import(/* webpackChunkName: "review-orders" */ './products/product-reviews'));

// Order Overview
export const OrderOverview = lazy(() => import(/* webpackChunkName: "order-overview" */ './finance/order-overview'));

// Account Statement
export const AccountStatement = lazy(
  () => import(/* webpackChunkName: "account-statement" */ './finance/account-statement')
);

// Buy Packages
export const BuyPackages = lazy(() => import(/* webpackChunkName: "buy-packages" */ './marketing/buy-packages'));

// Usage History
export const UsageHistory = lazy(() => import(/* webpackChunkName: "usage-history" */ './marketing/usage-history'));

// Chat
export const Chat = lazy(() => import('./chat'));

// Accounts & Settings - Manage Users
export const ManageUsers = lazy(
  () => import(/* webpackChunkName: "manage-users" */ './accounts-and-settings/manage-users')
);

// Accounts & Settings - Profile Settings
export const ProfileSettings = lazy(
  () => import(/* webpackChunkName: "profile-settings" */ './accounts-and-settings/profile-settings')
);

// Accounts & Settings - Chat Settings
export const ChatSettings = lazy(
  () => import(/* webpackChunkName: "chat-settings" */ './accounts-and-settings/chat-settings')
);

// Category Commission
export const CategoryCommission = lazy(
  () => import(/* webpackChunkName: "category-commission" */ './accounts-and-settings/category-commission')
);

export const TermsAndConditions = lazy(() => import('./accounts-and-settings/terms-and-conditions'));

// Add Product
export const AddProducts = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "add-products" */ './products/add-products')
);

// Order Details - Orders
export const OrderDetails = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "order-details" */ './orders/order-details')
);

//Account Statement Detail - Finance
export const AccountStatementDetails = lazy(
  () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "account-statement-details" */ './finance/account-statement-detail'
    )
);

export const NotFound = lazy(() => import(/* webpackPrefetch: true, webpackChunkName: "not-found" */ './not-found'));

export const ServerError = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "server-error" */ './server-error')
);

export const AccessDenied = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "access-denied" */ './access-denied')
);

export const StoreNotFound = lazy(
  () => import(/* webpackPrefetch: true, webpackChunkName: "store-not-found" */ './store-not-found')
);

// Accounts & Settings - Delivery Settings
export const DeliverySettings = lazy(
  () => import(/* webpackChunkName: "delivery-settings" */ './accounts-and-settings/delivery-settings')
);
